import React, { useState, useEffect } from 'react';
import CartInDecGroupBox from './CartInDecGroupBox';
import { useSelector, useDispatch } from 'react-redux';
import CurrencyCodeAdd from '@/components/common/CurrencyCodeAdd';
import { addOrUpdateCartItemPOS, updateCartItemQuantityPOS, removeFromCartPOS } from '@/store/actions';

const POSSidebarTable = () => {
    const { posOrder } = useSelector((state) => state?.GeneralSetting);
    const dispatch = useDispatch();

    const removeInToCart = (itemId, index) => {
        dispatch(removeFromCartPOS({ _id: itemId, index: index }));
    };

    const cartQuantityUpdate = (itemId, itemQuantity, cartIndex) => {
        dispatch(updateCartItemQuantityPOS({ _id: itemId, quantity: itemQuantity, index: cartIndex }));
    };

    const cartItemChange = async (name, value, index) => {
        const currentIndex = parseInt(index - 1);
        const cartItemsFind = posOrder?.cartItems[currentIndex] || '';
        if (cartItemsFind && cartItemsFind?._id) {
            cartQuantityUpdate(cartItemsFind?._id, value, currentIndex);
        }
    };

    return (
        <table className="w-full">
            <thead className="bg-primary-light">
                <tr className="h-9">
                    <th className="capitalize text-xs font-normal font-rubik text-left pl-3 text-heading"></th>
                    <th className="capitalize text-xs font-normal font-rubik text-left px-3 text-heading">Item</th>
                    <th className="capitalize text-xs font-normal font-rubik text-left px-3 text-heading">Qty</th>
                    <th className="capitalize text-xs font-normal font-rubik text-left px-3 text-heading">Price</th>
                </tr>
            </thead>
            <tbody>
                {posOrder?.cartItems &&
                    posOrder?.cartItems.length > 0 &&
                    posOrder?.cartItems.map((cart, index) => (
                        <tr key={index}>
                            <td className="pl-3 py-3 last:pr-3 align-top border-b border-[#EFF0F6] rtl:pr-3">
                                <button type="button" onClick={() => removeInToCart(cart?._id, index)}>
                                    <i className="lab lab-trash-line-2 font-fill-danger"></i>
                                </button>
                            </td>
                            <td className="pl-3 py-3 last:pr-3 align-top border-b border-[#EFF0F6]">
                                <h3 className="capitalize text-xs font-rubik text-[#2E2F38]">{cart?.name}</h3>
                                <p>
                                    {cart?.item_variations?._ids &&
                                        cart?.item_variations?._ids.length > 0 &&
                                        cart?.item_variations?._ids.map((item_variation, ind) => (
                                            <span key={ind}>
                                                <span className="capitalize text-[10px] leading-4 font-rubik text-heading">{cart?.item_variations?.attribute_name[ind]}: </span>
                                                <span className="capitalize text-[10px] leading-4 font-rubik">{cart?.item_variations?.name[ind]}</span>
                                            </span>
                                        ))}
                                </p>
                                <ul>
                                    <li className="leading-4">
                                        <span className="capitalize text-[10px] leading-4 font-rubik text-heading">Extras:</span>
                                        <p className="capitalize text-[10px] leading-4 font-rubik">
                                            {cart?.item_extras?._ids &&
                                                cart?.item_extras?._ids.length > 0 &&
                                                cart?.item_extras?._ids.map((item_extra, ind1) => (
                                                    <span key={ind1}>
                                                        {cart?.item_extras?.name[ind1]}
                                                        {ind1 < cart?.item_extras?._ids.length - 1 && ','}
                                                    </span>
                                                ))}
                                        </p>
                                    </li>
                                    {cart.instruction && cart.instruction !== '' && (
                                        <li className="leading-4">
                                            <span className="capitalize text-[10px] leading-4 font-rubik text-heading">Instruction:</span>
                                            <span className="capitalize text-[10px] leading-4 font-rubik">{cart.instruction}</span>
                                        </li>
                                    )}
                                </ul>
                            </td>
                            <td className="pl-3 py-3 last:pr-3 align-top border-b border-[#EFF0F6]">
                                <CartInDecGroupBox
                                    inputName="item_qty"
                                    cartId={cart?._id}
                                    indexKey={index + 1}
                                    onChangeValue={cartItemChange}
                                    inputValue={cart?.quantity}
                                    buttonClassName={'w-[18px] h-[18px]'}
                                />
                            </td>
                            <td className="pl-3 py-3 last:pr-3 align-top border-b border-[#EFF0F6] text-xs font-rubik text-heading">
                                <CurrencyCodeAdd price={cart.total_price} />
                            </td>
                        </tr>
                    ))}
            </tbody>
        </table>
    );
};

export default POSSidebarTable;
